/** Plan especial: entitlements 100% personalizados desde la ficha del cliente. */
export const CUSTOM_PLAN_ID = 'custom';

/** Codigos de producto del Agente Virtual (consumo). */
export const VIRTUAL_AGENT_PRODUCT_CODES = ['NTVA_CHAT', 'NTVA_VOZ', 'NTRV'];

/** Codigo del producto Auditores virtuales. */
export const VIRTUAL_AUDITOR_PRODUCT_CODE = 'NTVAA';

/**
 * Familia comercial "Agente Virtual": los codigos que se muestran agrupados en la
 * ficha del cliente. Es solo presentacion — el auditor NO da acceso a las secciones
 * de Agente Virtual, por eso queda fuera de VIRTUAL_AGENT_PRODUCT_CODES.
 */
export const VIRTUAL_AGENT_FAMILY_CODES = [
  ...VIRTUAL_AGENT_PRODUCT_CODES,
  VIRTUAL_AUDITOR_PRODUCT_CODE,
];

/** True si el codigo pertenece a la familia comercial de Agente Virtual. */
export function isVirtualAgentFamilyCode(code) {
  const owned = String(code || '');
  if (!owned) return false;
  return VIRTUAL_AGENT_FAMILY_CODES.some(
    (wanted) => owned === wanted || owned.startsWith(wanted) || wanted.startsWith(owned)
  );
}

/** True si el cliente tiene algun producto de Agente Virtual. */
export function hasVirtualAgentProduct(products) {
  if (!Array.isArray(products)) return false;
  return products.some((code) =>
    VIRTUAL_AGENT_PRODUCT_CODES.some((wanted) => {
      const owned = String(code || '');
      return (
        owned === wanted ||
        owned.startsWith(wanted) ||
        wanted.startsWith(owned)
      );
    }),
  );
}
